import { render, staticRenderFns } from "./InclusionsPage.vue?vue&type=template&id=a653b6e4"
import script from "./InclusionsPage.vue?vue&type=script&lang=js"
export * from "./InclusionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports